module.exports = __webpack_public_path__ + "static/media/proj2.4154b702.jpg";